var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tMap"},[_c('div',{ref:"tx_map_container",staticClass:"tMap"})])
}
var staticRenderFns = []

export { render, staticRenderFns }